// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c161bc08","977":"782ec268"}[chunkId] + ".chunk.js";
};